export default __webpack_public_path__ + "static/media/CC.bd16a37d.svg";